import { BMotionObject } from "../BMotionObject";
import { NumPair } from '../../Misc/Utils';
import { BObject } from "../BObject";

export const enum ShapeType {
    CIRCLE,
    RECTANGLE,
    VECTOR
}

/**
 * Base object for any shape to be drawn on the canvas
 */
export abstract class BShape extends BMotionObject{
    
    private shapeType : ShapeType

    protected _lineWidth = 2
    get lineWidth(): number{
        return this._lineWidth;
    }
    set lineWidth(val: number){
        if(val!=null && Number(val)!=NaN){
            this._lineWidth = val;
        } 
    }

    protected lineCapVals : CanvasLineCap[] = ["butt", "round", "square"]
    protected lineCap : CanvasLineCap = this.lineCapVals[0]
    protected lineJoinVals : CanvasLineJoin[] = ["bevel", "round", "miter"]
    protected lineJoin = this.lineJoinVals[0];

    protected _joinIndex = 0
    get joinIndex(): number{
        return this._joinIndex;
    }
    set joinIndex(index: number){
        if(index!=null && Number(index)!=NaN && index >=0 && index <=2){
            this._joinIndex = index;
            this.lineCap = this.lineCapVals[index];
            this.lineJoin = this.lineJoinVals[index];
        }
    }

    constructor(centre: NumPair, type : ShapeType, frameRange : NumPair){
        super(centre,[0,0], frameRange);
        this.shapeType = type;
        this.isVisible = true;
    }

    private preShapeDraw(canvasCtx : CanvasRenderingContext2D): void{
        this.colorMgr.setupCanvas(canvasCtx);
        canvasCtx.lineCap = this.lineCap
        canvasCtx.lineWidth = this.lineWidth;
        canvasCtx.lineJoin = this.lineJoin;
    }

    protected justDrawObj(canvasCtx : CanvasRenderingContext2D): void{
        this.preShapeDraw(canvasCtx);
        this.drawShape(canvasCtx);
    }

    protected abstract drawShape(canvasCtx : CanvasRenderingContext2D): void;

    public getShapeType(): ShapeType{
        return this.shapeType;
    }

    isColourable(): Boolean{
        return true;
    }

    protected duplicate(dupObj : BShape) : void{
        dupObj.joinIndex = this.joinIndex;
        dupObj.lineWidth = this.lineWidth;
        super.duplicate(dupObj);
    }

    /*public abstract clone() : BShape{
        var dupObj : BShape = new BShape(this.getXY(), this.getShapeType(), this.getFrameRange());
        super.duplicate(dupObj);
        return dupObj;
    }*/

}